import { render, staticRenderFns } from "./ArchiveArrowDown.vue?vue&type=template&id=2e31743f"
import script from "./ArchiveArrowDown.vue?vue&type=script&lang=js"
export * from "./ArchiveArrowDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports